var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"info-tooltip",class:_vm.s.container,on:{"click":function($event){return _vm.setShowTooltip(!_vm.showTooltip)}}},[_vm._v(" i "),(_vm.showTooltip)?_c('div',{class:_vm.s.tooltip,on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }